<template>
    <div id="app-vue-spreadsheet" :style="appVueSpreadSheet" class="bts-window-form">
        <div class="toolbar-container">
            
            <template v-if="processing || isAnyRowLoading">
                <mdb-btn color="elegant" size="sm" disabled class="btn btn-sm btn-elegant m-1">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Please wait...
                </mdb-btn>
            </template>
            <template v-else>
                <mdb-dropdown class="m-1">
                    <mdb-dropdown-toggle slot="toggle" color="elegant" size="sm">Generate Labels</mdb-dropdown-toggle>
                    <mdb-dropdown-menu >
                    <a class="dropdown-item" href="javascript:void(0)" @click="childClick('15x10-wh')">15x10CM - WH PRODUCT LABEL</a>
                    <a class="dropdown-item" href="javascript:void(0)" @click="childClick('39x58-wh')">3.9x5.8CM - WH PRODUCT LABEL</a>
                    <a class="dropdown-item" href="javascript:void(0)" @click="childClick('39x58-showroom')">3.9x5.8CM - SHOWROOM PRODUCT LABEL</a>
                    <a class="dropdown-item" href="javascript:void(0)" @click="childClick('29x39-showroom')">2.9x3.9CM - SHOWROOM PRODUCT LABEL</a>
                    </mdb-dropdown-menu>
                </mdb-dropdown>
            </template>

            <div class="d-inline-flex p-1">
                <el-radio-group v-model="connection" class="border border-info p-2 rounded">
                <el-radio label="QATL_PRODUCTION" class="mb-0">QATL_PRODUCTION</el-radio>
                <template v-if="checkSystemSupport">
                <el-radio label="QATL_DEV" class="mb-0">QATL_DEV</el-radio>
                </template>
                </el-radio-group>
            </div>
            <div class="d-inline-flex p-1 warehouse-select" style="width:300px;">
                <ThatsMultiSelect :multiple="false" :clearable="false"  labelClass="col-md-4" fieldClass="col-md-8  pl-0" label="WAREHOUSE" v-model="warehouse" :reduce="label => label.value" :reduceLabel="'label'" :options="warehouseFrom"  @select="setWarehouseFrom"></ThatsMultiSelect>
            </div>
        </div>
        <div ref="spreadsheetx"></div>
    </div>
</template>

<script>

import jspreadsheet from '../../jsexcel/jexcel'
import { userData } from '../../helpers/user'
import {mapActions} from 'vuex'
import { mdbBtn, mdbDropdown, mdbDropdownToggle, mdbDropdownMenu } from 'mdbvue';
import { ThatsMultiSelect} from '../../components/thats/Thats'
export default {
    components : {
        mdbBtn,
        mdbDropdown,
        mdbDropdownToggle,
        mdbDropdownMenu,
        ThatsMultiSelect
    },

    inject : ['showroomsProvider'],
    data() {

        const self = this;

        const batchDropdownFilter = function(instance, cell, c, r, source) {
            const options = self.batchOptionsByRow[r];
            console.log("batchDropdownFilter", options)
            if (Array.isArray(options)) {
                return options;
            }

            // No options set yet for this row → no dropdown choices
            return [];
        };
       /*  const batchDropdownFilter = function(instance, cell, c, r, source) {
            const rowData = instance.getRowData(r) || [];
            const itemCode = rowData[0]; 

        
            if (!itemCode) {
                return [];
            }
            const options = self.batchOptionsByRow[r];
            if (Array.isArray(options)) {
                return options;
            }
            return [];
        }; */

        const worksheetColumns = [
                    {
                        type: 'text',
                        width: '250px',
                        title: 'ITEM CODE',
                        align: 'left',
                        name: 'series',
                        readOnly: false,
                        primaryKey: true
                    },
                    {
                        type: 'text',
                        width: '150px',
                        title: 'UOM',
                        align: 'left',
                        name: 'uom_code',
                        readOnly: true,
                        primaryKey: false
                    },
                    {
                        type: 'text',
                        width: '250px',
                        title: 'UPC CODE',
                        align: 'left',
                        name: 'upc_code',
                        readOnly: true,
                        primaryKey: false
                    },
                    {
                        type:'dropdown',
                        width: '150px',
                        title: 'BATCH NO.',
                        align: 'left',
                        name: 'batch_number',
                        readOnly: false,
                        primaryKey: false,
                        source: [],
                        filter: batchDropdownFilter
                    },
                    {
                        type: 'number',
                        width: '160px',
                        title: 'AVAILABLE QUANTITY',
                        align: 'center',
                        name: 'qty',
                        readOnly: false,
                        primaryKey: false
                    },
                    {
                        type: 'hidden',
                        width: '100px',
                        title: 'UOM ENTRY',
                        align: 'center',
                        name: 'uom',
                        readOnly: true,
                        primaryKey: false
                    }

                ];
        return {
            connection : "QATL_PRODUCTION",
            isSave : false,
            appVueSpreadSheet : {
                width : 'calc(100vw - 240px)',
                height: 'calc(100vh - 45.43px)!important'
            },  
            warehouse : 43,
            width : 1300,
            height : 1024,
            dialogIsOpen : false,
            spreadsheet: null,
            spreadsheetexport: null,
            processing: false,
            exporData : [],
            exporDataSaving : false,
            generated_serial : "",
            showAlert: true,
            formData : null,
            rowLoading: {},
            batchOptionsByRow: {},
            alertMessage: "This print barcode is only for existing items.",
            alertColor: "info",
            options : {
                tableOverflow: true,
                tableWidth: "400px",
                tableHeight: "400px",
                wordWrap : true,
                allowDeleteColumn : false,
                allowRenameColumn : false,
                data:[[]],
                minDimensions:[1,30],
                columns: worksheetColumns        
            },
            exportTableOptions : {
                download : true,
                csvFileName : 'serial-number',
                allowDeleteColumn : false,
                allowRenameColumn : false,
                allowInsertColumn : false,
                csvHeader:true,
                tableWidth : 'calc(100vw - 255px)',
                tableHeight : 'calc(100vh - 140px)',
                tableOverflow : true,
                data:[[]],
                minDimensions:[1,30],
                onCopy : null,
                selectionCopy : false,
                allowCopy : true,
                columns: worksheetColumns,


                onchange: function(domElement, domElmentCell, column, row, value,oldValue){

                    if(column == 0){
                        
                        if((value != null && value != '' && value != oldValue) || (oldValue == '' && oldValue == null)){
                            console.log("onChange")
                            console.log(value,row)
                            self.fnGetItem(value,row)
                        }
                    }
                },

                onbeforepaste : function(instance, x1, y1, x2, y2, pastedValue) {
                    /* console.log("onbeforepaste", pastedValue)
                    const startRow = y1;
                    pastedValue.forEach((rowData, rowIndex) => {
                        const itemCode = rowData[0];
                        if (itemCode) {
                            const currentRow = startRow + rowIndex;
                            setTimeout(() => {
                                self.fnGetItem(itemCode, currentRow);
                            }, 0);
                        }
                    }); */

                    return ''
                }
              
            },
            user : null
        }
    },

    mounted() {

        this.exportTableOptions.tableWidth = `calc(100vw - 250px)`
        this.exportTableOptions.tableHeight = `calc(100vh - 140px)`
        this.spreadsheetexport = jspreadsheet(this.$refs.spreadsheetx, this.exportTableOptions);

        Object.assign(this, this.spreadsheetexport);

        
        
        this.height = window.innerHeight;
       
       this.setUser()

    },
    methods : {

        ...mapActions('ItemModule',['fetchSap']),
        ...mapActions('PrintDatamatrixModule',['storeRecord']),
        ...mapActions("UpcGeneratorModule", ["checkRecord"]),

        async setUser(){
        this.user = await userData()
            
        },
       async childClick(size){
            
            if(this.processing === false){
                this.exporDataSaving = false;
                
                const tableData = this.spreadsheetexport.getJson();
 
                if(tableData.length > 0){

                    console.log(tableData)
                    
                    const filterData = tableData.filter(function(rowElement){
                        return (rowElement.series != "");
                    },[])

                    if(filterData.length == 0){
                        this.$ThatsNotify.error({message : 'Please select at least one item', type : 'error'})
                        return false;
                    }

                    if(this.formData !== null && this.formData.id !== null){
                        this.onSubmitPrint(size)
                        return false;
                    }

                    console.log("filterData")
                    console.log(filterData)

                    if(filterData.length > 0){      
                        
                        const checkUpcCode = filterData.filter(function(rowElement){
                            return (rowElement.upc_code != "") ;
                        },[])

                        const checkUpcCodeLength = filterData.filter(function(rowElement){
                            return (rowElement.upc_code.length == 14);
                        },[])
                        
                        const checkBatch = filterData.filter(function(rowElement){
                            return (rowElement.batch_number != "");
                        },[])

                        const checkQuantity = filterData.filter(function(rowElement){
                            return (rowElement.qty != "" && rowElement.qty != 0);
                        },[])

                        console.log(`upc : ${checkUpcCode.length}, upc length : ${checkUpcCodeLength.length}, batch : ${checkBatch.length}, quantity : ${checkQuantity.length}`)

                        if(checkUpcCode.length != filterData.length){
                            this.$ThatsNotify.error({message : 'Please fill up all upc code', type : 'error'})
                            return false;
                        }

                        if(checkUpcCodeLength.length != filterData.length){
                            this.$ThatsNotify.error({message : 'Please enter valid upc code', type : 'error'})
                            return false;
                        }

                        if(checkBatch.length != filterData.length){
                            this.$ThatsNotify.error({message : 'Please fill up all batch', type : 'error'})
                            return false;
                        }
                        
                        if(checkQuantity.length != filterData.length){
                            this.$ThatsNotify.error({message : 'Please fill up all quantity', type : 'error'})
                            return false;
                        }

                        this.processing = true;
                        this.storeRecord({items : filterData}).then(response => {
                                    console.log("response");
                                    console.log(response.data)
                                    this.processing = false;
                                    this.formData = response.data;
                                    this.onSubmitPrint(size)
                                }).catch(error => {
                                    console.log("error");
                                    console.log(error);
                                    this.processing = false;
                                    this.formData = null;
                                });

                    }
                }
    
                
            }

        },

        onSubmitPrint(size){
            const self = this;

            if(self.formData !== null && self.formData.id !== null){
                var strWindowFeatures = "location=yes,height=600,width=900,scrollbars=yes,status=yes";

                const win = window.open(`/barcode/print-data-matrix/${self.formData.id}?size=${size}`, "_blank", strWindowFeatures);
                    win.document.title = 'Print';
                    win.print()
            }
        },


        createPopupTable(exportTableOptions){
            this.spreadsheetexport = jspreadsheet(this.$refs.spreadsheetexport, exportTableOptions);
            Object.assign(this, this.spreadsheetexport);
            this.spreadsheetexport.setWidth(window.innerWidth)
            this.spreadsheetexport.setData(this.exporData)
        },

        async recreateSpreadsheet(){
            await this.spreadsheetexport.destroy();
        },


        async fnGetItem(itemCode, index){
            const self = this;
            console.log("beforeFetchSap")
            console.log(itemCode,index)
            self.$set(self.rowLoading, index, true);
            self.formData = null;
            /* await self.fetchSap({item : itemCode, index : index}).then((res)=> {
                const row = parseInt((index + 1))
                console.log("afterFetchSap")
                console.log(res)

                const filteredBarcode = res.ItemBarCodeCollection.filter((item) => {
                    return item.UoMEntry == res.DefaultPurchasingUoMEntry;
                })

                if(filteredBarcode.length > 0){
                    const barcode = filteredBarcode[0];
                    console.log(barcode)
                    if(barcode){
                        self.spreadsheetexport.setValueFromCoords(1,index,barcode.UoMEntry,true)
                        self.spreadsheetexport.setValueFromCoords(2,index,barcode.Barcode,true)
                        
                    }
                    self.spreadsheetexport.setValueFromCoords(4,index,1,true)
                }
                self.$set(self.rowLoading, index, false);
            }).catch((error) => {
                console.log("catch")
                console.log(error)
                self.$set(self.rowLoading, index, false);
            }) */

            await this.checkRecord({item : itemCode, index : index, connection : self.connection, warehouse : self.warehouse}).then((response)=> {
                const {data : res} = response

                // const batches = (res.Batches || []).map(b => b.BatchNum);
                const batches = [...new Set((res.Batches || []).map(b => b.BatchNum))];
                console.log("batches",batches)

                self.$set(self.batchOptionsByRow, index, batches);

                const batchColIndex = 3;
                const batchColumn = self.spreadsheetexport.options.columns[batchColIndex];

                if (batchColumn) {
                    const existingSource = Array.isArray(batchColumn.source) ? batchColumn.source : [];
                    batchColumn.source = [...new Set([...existingSource, ...batches])];
                }

                if (batches.length > 0 && batches.length == 1) {
                    self.spreadsheetexport.setValueFromCoords(3, index, batches[0], true);
                    self.spreadsheetexport.setValueFromCoords(4,index,1,true)
                }

                const filteredBarcode = res.ItemBarCodeCollection.filter((item) => {
                    return item.UoMEntry == res.DefaultPurchasingUoMEntry;
                })

                if(filteredBarcode.length > 0){

                    const hasValidBarcode = filteredBarcode.filter((item) => {
                        return item.Barcode != "" && item.Barcode != null && item.Barcode.length == 14;
                    },[]);

                    if(hasValidBarcode.length > 0){
                        const barcode = hasValidBarcode[0];
                        self.spreadsheetexport.setValueFromCoords(5,index,barcode.UomEntry,true)
                        self.spreadsheetexport.setValueFromCoords(1,index,barcode.UomCode,true)
                        self.spreadsheetexport.setValueFromCoords(2,index,barcode.Barcode,true)
                    }

                    /* const barcode = filteredBarcode[0];
                    console.log(barcode)
                    if(barcode){
                        self.spreadsheetexport.setValueFromCoords(5,index,barcode.UomEntry,true)
                        self.spreadsheetexport.setValueFromCoords(1,index,barcode.UomCode,true)
                        self.spreadsheetexport.setValueFromCoords(2,index,barcode.Barcode,true)
                        
                    } */
                    
                }
                self.$set(self.rowLoading, index, false);
            }).catch(() => {
                self.$set(self.rowLoading, index, false);
            })
        },

        setWarehouseFrom(value){
        
            console.log("setWarehouseFrom")
            console.log(value)
        },
    },
    computed: {
        isAnyRowLoading() {
            return Object.values(this.rowLoading).some((v) => v);
        },
        checkSystemSupport : function(){
          return this.$helpers.isSystemAdministrator() || [424].includes(this.user?.user?.id);
      },
      warehouseFrom : function(){
        const showroom = this.showroomsProvider();
        return showroom.map((i) => {
          return {
            value : i.value,
            label : i.label
          }
        })
      },
    },

    watch : {

        dialogIsOpen : function(v){
            if(v === false){
                this.spreadsheetexport.destroy();
            }else{
                this.createPopupTable(this.exportTableOptions)                 
            }
        }
    }

}
</script>

<style scoped>
    .warehouse-select>span{
        width: 100% !important;
    }
</style>